export default __webpack_public_path__ + "static/media/meals2.73522ce9.jpg";